import { createContext, useContext, useState } from "react";

export const SkipEntranceContext = createContext(false);

/** Captured once at mount, so an element that skipped its entrance never replays it. */
export const useSkipEntranceOnMount = () => {
  const skipEntrance = useContext(SkipEntranceContext);
  const [skip] = useState(skipEntrance);
  return skip;
};
